<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <HorizontalMenu />
    <div class="right-menu">
      <template>
        <!-- <error-log class="errLog-container right-menu-item hover-effect" /> -->
        <projectSearch v-if="!projectItem.isDeadline" />
        <div
          class="right-menu-item hover-effect"
          @click="$router.push({name:'Screen'})"
        >
          <i class="el-icon-s-platform"></i>
          <div class="txt">
            {{ $t('navbar.dataScreen') }}
          </div>
        </div>
        <div
          v-permission="'siteHelpDocument'"
          class="right-menu-item hover-effect"
          @click="openHelpDocument"
        >
          <i class="el-icon-question"></i>
          <div class="txt">
            {{ $t('navbar.document') }}
          </div>
        </div>
        <div
          class="right-menu-item hover-effect"
          @click="taskTap"
        >
          <svgIcon icon-class="tasks" />
          <div class="txt">
            {{ $t('navbar.taskCenter') }}
          </div>
        </div>

        <!-- <el-tooltip :content="$t('navbar.size')" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip>-->

        <!-- <lang-select class="right-menu-item hover-effect" /> -->
      </template>

      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
        @command="handleCommand"
      >
        <div class="avatar-wrapper">
          <img
            v-if="userAvatar"
            :src="userAvatar"
            class="user-avatar"
          />
          <svgIcon
            v-else
            icon-class="touxiang"
            class="touxiang"
          />
          <span class="username">{{ userInfo.tenementUserName }}</span>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <!-- <router-link to="/profile/index"> -->
          <el-dropdown-item command="profile">
            <i class="el-icon-user-solid"></i>
            {{ $t('navbar.profile') }}
          </el-dropdown-item>
          <el-dropdown-item command="updatePassword">
            <i class="el-icon-key"></i> {{ $t('login.updatePassword') }}
          </el-dropdown-item>
          <!-- </router-link> -->
          <!-- <router-link to="/">
            <el-dropdown-item>{{ $t('navbar.dashboard') }}</el-dropdown-item>
          </router-link> -->
          <el-dropdown-item
            divided
            @click.native="logout"
          >
            <el-button
              :loading="loading"
              type="text"
            >
              <svgIcon
                style="vertical-align: -0.1em;"
                icon-class="tuichu2"
              /> {{ $t('navbar.logOut') }}
            </el-button>
            <!-- <span style="display:block;">{{  }}</span> -->
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <screenfull
        style="padding-right:20px"
        class="right-menu-item hover-effect"
      />

    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Hamburger from '@/components/Hamburger'
// import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
// import LangSelect from '@/components/LangSelect'
import { generateTitle } from '@/utils/i18n'
import projectSearch from './projectSearch.vue'
import screenfull from '@/components/Screenfull/index.vue'
import HorizontalMenu from './HorizontalMenu.vue'
import { $_isMobile } from '@/utils/index'
export default {
  components: {
    Hamburger,
    projectSearch,
    screenfull,
    HorizontalMenu
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device']),
    ...mapState({
      levelRoute: (state) => {
        return state.permission.routes.filter((item) => !item.hidden)
      },
      userAvatar: (state) => state.user.userInfo.tenementUserAvatarUrl,
      userInfo: (state) => state.user.userInfo,
      projectItem: (state) => state.user.projectItem
    }),
    activeIndex: function () {
      const route = this.$route
      let path = route.fullPath.split('/')[1]
      if (path === 'dashboard') {
        path = ''
      }
      return '/' + path
    },
    isMobile: function () {
      return $_isMobile()
    }
  },
  methods: {
    toggleSideBar() {
      if (
        this.$route.path !== '/dashboard' &&
        this.$route.path !== '/personnel/personnel-list'
      ) {
        this.$store.dispatch('app/toggleSideBar')
      }
    },
    async logout() {
      try {
        this.loading = true
        await this.$store.dispatch('user/logout', {
          clientType: 'WEB_SITE_C',
          clientSecret: '0253412833854261839721174600a270'
        })
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
        location.reload()
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    generateTitle,
    taskTap() {
      this.$store.commit('user/SET_TASK_DIALOG_VISI', true)
    },
    handleCommand(e) {
      if (e === 'profile') {
        this.$store.dispatch('user/setUserDialogVisi', true)
      } else if (e === 'updatePassword') {
        this.$store.dispatch('user/setUpdatePasswordVisi', true)
      }
    },
    openHelpDocument() {
      const routeData = this.$router.resolve({ path: '/help-document' })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.iconItem {
  display: inline-block;
  height: 100%;
  padding-top: 1%;
  margin-right: 10px;
  color: #666;
  cursor: pointer;
  i {
    font-size: 18px;
    vertical-align: middle;
  }
}
.username {
  display: inline-block;
  margin-left: 4px;
  font-size: 14px;
}
.navbar {
  height: 60px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;

  .hamburger-container {
    line-height: 60px;
    height: 100%;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    .svgIcon {
      vertical-align: -0.1em;
    }
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    display: flex;
    height: 60px;
    align-items: center;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      padding: 0 10px;
      color: #666666;
      height: 100%;
      .txt {
        font-size: 12px;
        margin-top: 4px;
      }
      // padding: 0 8px;
      // height: 100%;
      // font-size: 18px;
      // color: #5a5e66;

      // .task{
      //   font-size: 16px;
      //   vertical-align: -0.3em;
      //   padding-left: 4px;
      // }
      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 10px;

      .avatar-wrapper {
        position: relative;
        display: flex;
        // justify-content: center;
        align-items: center;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .touxiang {
          font-size: 40px;
          color: #666;
          vertical-align: middle;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -12px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
